import { ossConstants } from "./oss.constants";

export function oss(state = {}, action) {
    switch (action.type) {
        case ossConstants.GET_YEARLY_SALES_OVERVIEW_REQUEST:
            return {
                ...state,
                loading: true,
                overviewErrorMessage: null,
                overviewData: null,
            };

        case ossConstants.GET_YEARLY_SALES_OVERVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                overviewData: action.result,
            };

        case ossConstants.GET_YEARLY_SALES_OVERVIEW_FAILURE:
            return {
                ...state,
                loading: false,
                overviewErrorMessage: action.errorMessage,
            };

        case ossConstants.PERFORM_TAX_CHECK_REQUEST:
            return {
                ...state,
                taxCheckLoading: true,
                taxCheckErrorMessage: null,
                taxCheckData: null,
            };

        case ossConstants.PERFORM_TAX_CHECK_SUCCESS:
            return {
                ...state,
                taxCheckLoading: false,
                taxCheckData: action.result,
            };

        case ossConstants.PERFORM_TAX_CHECK_FAILURE:
            return {
                ...state,
                taxCheckLoading: false,
                taxCheckErrorMessage: action.errorMessage,
            };

        case ossConstants.REFRESH_OSS_DASHBOARD_REQUEST:
            return {
                ...state,
                refreshLoading: true,
                refreshErrorMessage: null,
            };

        case ossConstants.REFRESH_OSS_DASHBOARD_SUCCESS:
            return {
                ...state,
                refreshLoading: false,
            };

        case ossConstants.REFRESH_OSS_DASHBOARD_FAILURE:
            return {
                ...state,
                refreshLoading: false,
                refreshErrorMessage: action.errorMessage,
            };

        case ossConstants.POLL_YEARLY_SALES_OVERVIEW_SUCCESS:
            return {
                ...state,
                overviewData: action.result,
            };

        default:
            return state;
    }
}

